import { createSlice } from '@reduxjs/toolkit';

const getStoredLogoUrl = () => {
  try {
    return localStorage.getItem('logoUrl') || '';
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return '';
  }
};

const initialState = {
  logoUrl: getStoredLogoUrl(),
};

const logoSlice = createSlice({
  name: 'logo',
  initialState,
  reducers: {
    setLogoUrl: (state, action) => {
      state.logoUrl = action.payload;
      try {
        localStorage.setItem('logoUrl', action.payload);
      } catch (error) {
        console.error('Error saving to localStorage:', error);
      }
    },
    clearLogoUrl: (state) => {
      state.logoUrl = '';
      try {
        localStorage.removeItem('logoUrl');
      } catch (error) {
        console.error('Error clearing localStorage:', error);
      }
    },
    restoreLogoUrl: (state) => {
      if (state.logoUrl && !getStoredLogoUrl()) {
        try {
          localStorage.setItem('logoUrl', state.logoUrl);
        } catch (error) {
          console.error('Error restoring to localStorage:', error);
        }
      }
    },
  },
});

export const { setLogoUrl, clearLogoUrl, restoreLogoUrl } = logoSlice.actions;
export default logoSlice.reducer;